import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import type { ConfirmedHarmonisedStandard } from '@/v2/lib/confirmedHarmonisedStandards'

type ConfirmedHarmonisedStandardsStepProps = {
  standards: ConfirmedHarmonisedStandard[]
  canWrite: boolean
  onEditStandards: () => void
  i18nKeyPrefix: string
  stepShell: (props: {
    actions?: ReactNode
    children?: ReactNode
  }) => ReactNode
}

export function ConfirmedHarmonisedStandardsStep({
  standards,
  canWrite,
  onEditStandards,
  i18nKeyPrefix,
  stepShell,
}: ConfirmedHarmonisedStandardsStepProps) {
  const { t } = useTranslation('common')

  const actionLabel =
    standards.length > 0
      ? t(`${i18nKeyPrefix}.actionEdit`)
      : t(`${i18nKeyPrefix}.actionAdd`)

  return stepShell({
    actions: canWrite ? (
      <Button
        type='button'
        size='sm'
        variant='outline'
        onClick={onEditStandards}
      >
        {actionLabel}
      </Button>
    ) : undefined,
    children:
      standards.length === 0 ? (
        <p className='text-sm text-muted-foreground'>
          {t(`${i18nKeyPrefix}.empty`)}
        </p>
      ) : (
        <ul className='space-y-2 text-sm text-muted-foreground'>
          {standards.map((standard) => (
            <li key={standard.designation}>
              <span className='font-medium text-foreground'>
                {standard.designation}
              </span>
              {standard.title ? (
                <span className='block text-muted-foreground'>
                  {standard.title}
                </span>
              ) : null}
            </li>
          ))}
        </ul>
      ),
  })
}
